import { Link, useLocation, useRoute } from 'wouter-preact'

import codigoLogo from 'assets/icons/codigo-logo.svg'

const CodigoLogoButton = () => {
	const [, navigate] = useLocation()
	const [isOnWorkspacePage] = useRoute('/smart-contract/:dAppName/workspace')

	if (!isOnWorkspacePage) {
		return (
			<Link href='~/'>
				<img alt='Código logo' class='h-8' src={codigoLogo} />
			</Link>
		)
	}

	const handleClick = () => {
		// If the user is in the workspace, the logo should open a new tab and go to the home page.
		if (isOnWorkspacePage) {
			window.open('/', '_blank', 'noopener noreferrer')
			return
		}

		// If the user is not in the workspace, the logo should navigate to the home page.
		navigate('~/')
	}

	return (
		<button onClick={handleClick} type='button'>
			<img alt='Código logo' class='h-8' src={codigoLogo} />
		</button>
	)
}

export { CodigoLogoButton }
